import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
export var formatExpiry = function formatExpiry(input, prev) {
  if (prev == input) {
    input = input.slice(0, 1);
  }

  var sanitizedInput = input.replace(/[^\d]/g, '');

  if (sanitizedInput.length == 2) {
    if (input.endsWith('/')) {
      return sanitizedInput.slice(0, 2);
    } else {
      if (parseInt(sanitizedInput.slice(0, 2)) > 12) {
        return sanitizedInput;
      }

      return sanitizedInput;
    }
  }

  if (sanitizedInput.length > 2) {
    return sanitizedInput.slice(0, 2) + '/' + sanitizedInput.slice(2, 4);
  }

  return sanitizedInput;
};
export var validateExpiry = function validateExpiry() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (!value || value === '') {
    return false;
  }

  var regex = /^(0[1-9]|1[0-2])\/?([0-9]{2})$/;

  if (regex.test(value)) {
    // Parse MM/YY
    var _value$split$map = value.split('/').map(Number),
        _value$split$map2 = _slicedToArray(_value$split$map, 2),
        expMonth = _value$split$map2[0],
        expYear = _value$split$map2[1];

    var currentYear = new Date().getFullYear() % 100; // Get last two digits of the current year

    var currentMonth = new Date().getMonth() + 1; // getMonth is 0-based
    // Handle the comparison

    return expYear > currentYear || expYear === currentYear && expMonth >= currentMonth;
  } else {
    return false;
  }
};